import { cn } from "@/lib/utils";
import { InfoIcon } from "lucide-react";
import type { ComponentProps, ReactNode } from "react";

/**
 * Shell of the people tools' cards in the thread — the bordered one-line card
 * the chat's other tool cards (a document, a company read) are drawn as.
 */
export function PeopleToolCard({
  className,
  children,
  ...props
}: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "mb-2 flex w-full flex-col gap-1.5 rounded-xl border bg-background p-3 not-prose",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

/** A limit or a caveat a card states, so the table cannot be misread. */
export function PeopleToolNotice({ children }: { children: ReactNode }) {
  return (
    <p className="flex gap-1.5 items-start text-xs text-muted-foreground">
      <InfoIcon className="size-3.5 mt-px shrink-0" />
      <span>{children}</span>
    </p>
  );
}
